import React, { useEffect, useState } from "react";
import { ReactComponent as WhatsappIcon } from "assets/svgs/whatsapp-black.svg";
import { ReactComponent as Mail } from "assets/svgs/email.svg";
import { ReactComponent as CopyIcon } from "assets/svgs/copy.svg";
import { ReactComponent as RightArrow } from "assets/svgs/right-arrow-in-orange.svg";
import CopyButton from "assets/images/copy-in-orange.png";
import { useGlobalContext } from "context/global";
import { useSelector } from "react-redux";
import Image from "components/image";
import Link from "helpers/link";
import clsx from "clsx/lite";
import { formatTitle } from "helpers/format-title";
import extractIdFromGid from "helpers/extract-gid";
import { toast } from "react-toastify";
import { SHOPIFY_DOMAIN } from "utils/constants";

const ReferFriend = ({ data }) => {
	const { id, emailAddress: { emailAddress } } = useSelector((state) => state.account.profile);
	const { translation } = useGlobalContext();
	const { isAuthenticated, digest } = useSelector((state) => state.account.profile);
	const [isCopied, setIsCopied] = useState(false);

	useEffect(() => {
		if (digest && data.showInviteOptions) {
			const script = document.createElement("script");
			script.src = "https://widgets.influence.io/dist/referral/main.js";
			script.defer = true;

			script.onload = () => {
				if (window.influenceioReferralWidget)
					setTimeout(() => window.influenceioReferralWidget("influenceio-widget-mount"), 500);
			};

			script.onerror = () => {
				console.error("Failed to load Influence.io script");
			};

			document.body.appendChild(script);

			return () => {
				if (script) document.body.removeChild(script);
			};
		}
	}, [digest]);


	const handleShareDestination = (e, index) => {
		e.preventDefault();
		const elements = document.querySelectorAll("#influenceio-widget-mount .LoyaltyPanel__inner .R-flex-col-xxs-3");
		if (elements.length > index)
			elements[index]?.click();
		else
			toast.error("An error occurred while sharing the link");
	};

	const handleCopy = async (e) => {
		e.preventDefault();
		const element = document.querySelector("#influenceio-widget-mount .LoyaltyPanel__inner .R-Button");

		if (element) {
			element?.click();
			setIsCopied(true);
		}
		else toast.error("An error occurred while copying the link");

	};

	const ShareOption = ({ icon, text, onClick, className, href = "#", isCopy = false }) => (
		<div className="flex w-full justify-between py-2 border-t border-[#C0C0C0]">
			<div className={clsx("flex items-center", className)}>
				{icon} <span>{text}</span>
			</div>
			{isAuthenticated && digest ?
				<Link to={href} onClick={onClick} target={href.startsWith("http") ? "_blank" : undefined} rel="noreferrer">
					{isCopy ?
						<img className="w-[4.5rem]" src={CopyButton} alt="copy" role="presentation" aria-hidden="true" /> :
						<RightArrow />}
				</Link>
				: <Link to="/account/login">
					{isCopy ?
						<img className="w-[4.5rem]" src={CopyButton} alt="copy" role="presentation" aria-hidden="true" /> :
						<RightArrow />}
				</Link>
			}
		</div>
	);

	return (
		<div className={clsx(
			"flex items-center gap-8 lg:gap-16 hd-screen-max-width",
			data.alternate ? "lg:flex-row-reverse flex-col !mx-10" : "lg:flex-row flex-col-reverse py-10 mx-5",
		)}>
			<div className="w-full mx-auto">
				<Image className="mx-auto rounded-3xl" image={data.image} />
			</div>
			<div className="flex flex-col gap-5 items-center lg:items-start w-full">
				<div className="flex flex-col gap-3 items-center lg:items-start text-center">
					<h2 className="text-h3 lg:text-3xl lg:text-left">{formatTitle(data.title)}</h2>
					{data.subtitle && <p className="lg:text-left">{data.subtitle}</p>}
				</div>
				{data.buttonText && data.buttonUrl &&
					<Link to={data.buttonUrl} className="btn-primary w-fit uppercase text-sm">{data.buttonText}</Link>}

				{data.highlights &&
					<div className="flex bg-white shadow-xl p-8 gap-4 rounded-md">
						{data.highlights.map((highlight, index) => (
							<div className="flex gap-2 flex-1 flex-col justify-start items-center text-center" key={index}>
								<Image className="max-w-14" image={highlight.icon} />
								<span className="text-sm">{highlight.text}</span>
							</div>
						))}

					</div>
				}
				<div></div>
				{data.showInviteOptions && <div className="w-full">
					<div className="w-full">
						<ShareOption
							icon={<Mail className="[&>path]:fill-black" />}
							text="Email" onClick={(e) => handleShareDestination(e, 2)} className="gap-3" />
						<ShareOption
							icon={<WhatsappIcon />} text="WhatsApp" className="gap-3" onClick={(e) => handleShareDestination(e, 3)} />
						<ShareOption icon={<CopyIcon />}
							text={isCopied ? translation.other.linkCopied : translation.other.copyLink}
							onClick={handleCopy} className="gap-4" isCopy />
					</div>
				</div>}
			</div>
			<div id="influenceio-widget-mount" className="hidden"></div>
			<div
				className="influenceio-widgets-init hidden"
				data-shop={SHOPIFY_DOMAIN}
				data-platform="api"
				data-customer-email={emailAddress}
				data-customer-id={extractIdFromGid(id)}
				data-customer-digest={digest}
			></div>
		</div>
	);
};

export default ReferFriend;
